module.exports = __webpack_public_path__ + "img/homeCoreTech.ed14255.png";